import { Voslogicimages } from "./Voslogicimages";
export const Compareslider = [
  {
    img: Voslogicimages.voice,
    title: "VOICE CONVERSATIONAL",
  },
  {
    img: Voslogicimages.statement,
    title: "SENTIMENT RECOGNITION",
  },
  {
    img: Voslogicimages.intelligent,
    title: "INTELLIGENT ASSISTANCE FOR AGENTS",
  },
  {
    img: Voslogicimages.scal,
    title: "SCAL",
  },
  {
    img: Voslogicimages.contorl,
    title: "CONTROL",
  },
  {
    img: Voslogicimages.complte,
    title: "COMPLIANCE",
  },
  {
    img: Voslogicimages.conver,
    title: "CONVERSATIONAL",
  },
];
